import React from 'react';
import RacePagination from '../pagination/racePagination';
import PageSizeSelector from '../pageSizeSelector/pageSizeSelector';
import { PageSize } from '../hooks/usePagination';

interface PaginationControlsProps {
	currentPage: number;
	currentPageSize: PageSize;
	maxPage: number | null;
	raceType: string;
	onPageChange: (page: number) => void;
	onPageSizeChange: (pageSize: PageSize) => void;
}

export default function PaginationControls({
	currentPage,
	currentPageSize,
	maxPage,
	raceType,
	onPageChange,
	onPageSizeChange,
}: PaginationControlsProps) {
	return (
		<div className="paginationContainerRow">
			<PageSizeSelector pageSize={currentPageSize} onChange={onPageSizeChange} />
			<RacePagination
				maxPages={maxPage}
				currentPage={currentPage}
				setCurrentPage={onPageChange}
				raceType={raceType}
			/>
		</div>
	);
}

